import { TrendingUp } from "lucide-react";
import {
    Bar,
    BarChart,
    CartesianGrid,
    XAxis,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { Card, CardContent, CardFooter } from "@/components/ui/card";

export default function MarginChart(data: any) {
    const allMonths = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const chartData = allMonths.map((month) => ({
        month,
        margin: data.data[month]?.toFixed(2) ?? 0, // Use default value if month is missing
    }));

    const currentDate = new Date();
    const currentMonth = currentDate.toLocaleString("en-US", { month: "long" });
    const currentMonthIndex = currentDate.getMonth();
    const previousMonth = allMonths[currentMonthIndex - 1] || "December"; // Handle January case

    // Assuming data.data contains the values for each month
    const currentValue = data.data[currentMonth] ?? 0;
    const previousValue = data.data[previousMonth] ?? 0;

    // Calculate percentage change
    const percentageChange =
        previousValue === 0
            ? 0
            : ((currentValue - previousValue) / Math.abs(previousValue)) * 100;

    return (
        <Card className="w-full">
            <CardContent>
                <div className="h-60 w-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartData}>
                            <CartesianGrid
                                vertical={false}
                                strokeDasharray="3 3"
                            />
                            <XAxis
                                dataKey="month"
                                tickLine={false}
                                tickMargin={8}
                                axisLine={false}
                                tickFormatter={(value) => value.slice(0, 3)}
                            />
                            <Tooltip
                                cursor={{ fill: "rgba(0, 0, 0, 0.1)" }}
                                contentStyle={{
                                    background: "white",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    padding: "8px",
                                }}
                            />
                            <Bar
                                dataKey="margin"
                                fill="hsl(221.2 83.2% 53.3%)"
                                radius={[8, 8, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </CardContent>
            <CardFooter className="flex flex-col items-start gap-2">
                <div className="flex items-center gap-2 font-medium">
                    Trending up by {percentageChange.toFixed(2)}% this month{" "}
                    <TrendingUp className="h-4 w-4" />
                </div>
                <div className="text-sm text-muted-foreground">
                    Showing current margin of year{" "}
                    {data.year === new Date().getFullYear()
                        ? new Date().getFullYear()
                        : new Date().getFullYear() - 1}
                </div>
            </CardFooter>
        </Card>
    );
}
